import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

import type { UserWithRole } from './types';

interface UserState {
  currentUser: UserWithRole | null;
  currentUserId: string | null;
}

type SetCurrentUser = (user: UserWithRole) => void;

const initialUserState: UserState = {
  currentUser: null,
  currentUserId: null,
};

export const useUserStore = create<UserState & { setCurrentUser: SetCurrentUser }>()(
  devtools(
    persist(
      (set) => ({
        ...initialUserState,
        setCurrentUser: (user: UserWithRole) => {
          set((state) => ({
            ...state,
            currentUser: user,
            currentUserId: user.id,
          }));
        },
      }),
      {
        name: 'user-storage',
      },
    ),
  ),
);

// Hook to access setCurrentUser
export const useSetCurrentUser = () =>
  useUserStore((state) => state.setCurrentUser);

// Function to set user directly
export const setCurrentUser = (user: UserWithRole) => {
  useUserStore.setState({
    currentUser: user,
    currentUserId: user.id,
  });
};

// Function to get user directly
export const getCurrentUser = () => {
  return useUserStore.getState().currentUser;
};

// Hook to access currentUser
export const useCurrentUser = () =>
  useUserStore((state) => state.currentUser);

